import moment from 'moment';
import {useEffect, useRef} from 'react';
// import {FFmpeg} from '@ffmpeg/ffmpeg';
// const fetchFile = (await import('@ffmpeg/util')).fetchFile;
import {fetchFile} from '@ffmpeg/util';

export const useFFmpeg = () => {
  const ffmpegRef: any = useRef();

  const loadFFmpeg = async () => {
    const FFmpeg = (await import('@ffmpeg/ffmpeg')).FFmpeg;
    const {toBlobURL} = await import('@ffmpeg/util');
    // import {fetchFile, toBlobURL} from '@ffmpeg/util';
    ffmpegRef.current = new FFmpeg();

    const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd';
    const ffmpeg = ffmpegRef.current;

    await ffmpeg.load({
      coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
      wasmURL: await toBlobURL(
        `${baseURL}/ffmpeg-core.wasm`,
        'application/wasm'
      ),
    });
  };

  useEffect(() => {
    loadFFmpeg();
  }, []);

  const compressVideo = async (videoBlob: string | Blob | File | undefined) => {
    const ffmpeg = ffmpegRef.current;
    const startTime = moment();
    // const fetchFile = (await import('@ffmpeg/util')).fetchFile;
    await ffmpeg.writeFile('input.mp4', await fetchFile(videoBlob));
    await ffmpeg.exec([
      '-i',
      'input.mp4',
      '-vcodec',
      'h264',
      '-b:v',
      '1000k',
      '-acodec',
      'mp3',
      '-preset',
      'ultrafast',
      'output.mp4',
    ]);
    const data: any = await ffmpeg.readFile('output.mp4');
    const newBlob = new Blob([data.buffer], {type: 'video/mp4'});
    const endtime = moment();
    console.log(endtime.diff(startTime, 'seconds'), 'seconds');

    return newBlob;
  };

  return {compressVideo};
};
